<h1>Datenschutzerklärung</h1>

<app-version-notice
  [match]="versionMatch"
  (reloadRequested)="onReloadRequested()"
></app-version-notice>

<app-privacy-policy-content></app-privacy-policy-content>

<div class="approval" [hidden]="!showApproveButton">
  <!--
    Häkchen und Knopf nebeneinander sparen Höhe, die dem Text zugutekommt. Die Reihenfolge im
    Markup bleibt die des Ablaufs - erst bestätigen, dann zustimmen -, also auch die beim
    Durchtabben.
  -->
  <div class="approval-row">
    <jf-checkbox
      formControlId="eula-accepted"
      label="Datenschutzerklärung gelesen und akzeptiert"
      [formControl]="acceptedControl"
      (changed)="onAccepted($event)"
    ></jf-checkbox>

    <jf-button
      variant="primary"
      [text]="approveText"
      [disabled]="disabled"
      (doClick)="approve()"
    ></jf-button>
  </div>

  <!--
    Eine einzige Zeile für alle Meldungen des Zustimmungsbereichs, unterhalb der Bedienelemente
    statt zwischen ihnen: Dort schöbe sie den Knopf zur Seite. role=status meldet sie auch dann,
    wenn der Knopf beim Ausgrauen den Fokus verloren hat.
  -->
  <p
    class="approval-status"
    [class.approval-status--warning]="statusIsWarning"
    role="status"
    aria-live="polite"
  >{{ statusMessage }}</p>
</div>
